import React from 'react';
import { useIntl } from 'umi';
import accessIcon from '@sg/assests/svg/access.svg';
import './index.scss';

interface AccessRestrictedProps {
  /** Custom administrators to display */
  admins?: string[];
  /** Custom restriction message */
  message?: string;
}

const AccessRestricted: React.FC<AccessRestrictedProps> = ({
  admins = ['kirashi', 'judymao'],
  message,
}) => {
  const { formatMessage } = useIntl();

  const defaultMessage = `Access to this page is limited to authorized users only.\nTo request access, please reach out to administrators ${admins.join(' or ')}.`;

  return (
    <div className="dbs-access-restricted">
        <div className="dbs-access-restricted__content">
            {/* Access Restricted Icon from Figma */}
            <div className="dbs-access-restricted__icon">
            <img src={accessIcon} alt="Access Restricted" />
            </div>

            {/* Title */}
            <div className="dbs-access-restricted__title">
            Access Restricted
            </div>

            {/* Message */}
            <div className="dbs-access-restricted__message">
            {message || defaultMessage}
            </div>
        </div>
    </div>
  );
};

export default AccessRestricted;
